import { render, staticRenderFns } from "./ProjectMappingRuleUpdate.vue?vue&type=template&id=74c3f682&"
import script from "./ProjectMappingRuleUpdate.vue?vue&type=script&lang=js&"
export * from "./ProjectMappingRuleUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports